export const PRIORITY = {

    "LOW": "LOW",
    "MEDIUM": "MEDIUM",
    "HIGH": "HIGH"
};